<template>
  <div>
    <vxe-grid
      auto-resize
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :loading="loading"
      :height="tableHeight"
      ref="gridTable"
      size="small"
      resizable
      border
      :seq-config="{
        startIndex: (tablePage.curPage - 1) * tablePage.pageSize,
      }"
    >
      <template v-slot:toolbar_form>
        <slot name="header"></slot>
      </template>
      <template v-slot:pager>
        <slot name="pager"></slot>
      </template>
      <template v-slot:status="{ row }">
        <el-tag
          size="mini"
          :type="row.icechopsStatus === 'Y' ? 'light' : 'warning'"
        >
          {{ row.v_icechopsStatus }}
        </el-tag>
      </template>
      <template v-slot:inFreezerStatus="{ row }">
        <el-tag
          size="mini"
          v-if="row.inFreezerStatus"
          :type="row.inFreezerStatus === 'I' ? 'light' : 'warning'"
        >
          {{ row.v_inFreezerStatus }}
        </el-tag>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip class="item" effect="dark" content="查看" placement="top">
            <i
              class="el-icon-view tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'detail',
                  code: row.icechopsCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="编辑"
            v-allow="'actModify'"
            placement="top"
            v-if="row.icechopsStatus === 'Y'"
          >
            <i
              class="el-icon-edit tool-btn"
              @click="
                $emit('openEditFormDialog', {
                  type: 'edit',
                  code: row.icechopsCode,
                })
              "
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="删除"
            v-allow="'actDel'"
            placement="top"
            v-if="row.icechopsStatus === 'Y' && row.inFreezerStatus !== 'T'"
          >
            <i
              class="el-icon-delete tool-btn"
              @click="del(row.icechopsCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="返程确认"
            placement="top"
            v-allow="'back'"
            v-if="row.icechopsStatus === 'Y' && row.inFreezerStatus === 'T'"
          >
            <i
              class="el-icon-circle-check tool-btn"
              @click="back(row.icechopsCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="打印"
            v-allow="'actPrint'"
            placement="top"
          >
            <i
              class="el-icon-printer tool-btn"
              @click="detailPrint(row.icechopsCode)"
            ></i>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            content="查看出入柜操作日志"
            v-allow="'actPrint'"
            placement="top"
          >
            <i
              class="el-icon-shopping-cart-full tool-btn"
              @click="lookIcechopslog(row.icechopsCode)"
            ></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:empty="{}">
        <div style="text-align: center">
          <img src="/image/static/img/nodata.png" />
          <p class="no-data">暂无数据！</p>
        </div>
      </template>
    </vxe-grid>
  </div>
</template>
<script>
import TableAutoHeight from '@/mixins/table-auto-height'
import tableColumns from './table-columns'
export default {
  mixins: [TableAutoHeight],
  props: {
    tableData: { type: Array, default: () => [] },
    tablePage: { type: Object, default: () => {} },
    loading: { type: Boolean, default: false },
  },
  components: {},
  data() {
    return {
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
        refresh: {
          query: () => this.$emit('reload'),
        },
        zoom: true,
        custom: true,
      },
      tableColumns: tableColumns(),
    }
  },
  methods: {
    del(icechopsCode) {
      this.$confirm('确认要删除该记录吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$api.masterIcechopsDelApi({ icechopsCode }).then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
    getSelectData() {
      // 缓存的选中数据，非当前页数据
      let reserveRecords = this.$refs.gridTable.getCheckboxReserveRecords()
      // 当前页选中的数据
      let selectRecords = this.$refs.gridTable.getCheckboxRecords()
      let totCount = reserveRecords.length + selectRecords.length
      if (totCount === 0) {
        this.$message.warning('请选择需要批量处理的数据')
        return false
      }
      this.codeList = []
      // 将缓存中的选中数据，加入已选中数据列表
      if (reserveRecords.length > 0) {
        reserveRecords.forEach((row) => {
          this.codeList.push(row.icechopsCode)
        })
      }
      // 将当前页选中数据，加入已选中数据列表
      if (selectRecords.length > 0) {
        selectRecords.forEach((row) => {
          this.codeList.push(row.icechopsCode)
        })
      }
      if (totCount > 20) {
        this.$message.warning('每次批量选择的数据数量，不能超过20条')
        return false
      }
      return true
    },
    //打印
    detailPrint(code) {
      this.codeList = []
      this.codeList.push(code)
      this.$api.printPDF('/master/icechops/print', {
        icechopsCodeList: this.codeList,
      })
    },
    //批量打印
    async batchDetailPrint() {
      const selectCode = await this.getSelectData()
      if (!selectCode) return
      this.$api.printPDF('/master/icechops/print', {
        icechopsCodeList: this.codeList,
      })
    },
    lookIcechopslog(code) {
      this.$router.push({
        name: 'master-Icechopslog',
        params: { code },
      })
    },
    back(icechopsCode) {
      this.$confirm('确认返程吗？', '确认信息', {
        type: 'warning',
      }).then(() => {
        this.$api.masterIcechopsbackApi({ icechopsCode }).then((res) => {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'success',
          })
          this.$emit('reload')
        })
      })
    },
  },
}
</script>
